import { defineComponent as _defineComponent } from 'vue'


// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalLinkView',
  props: {
  externallink: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})